import { useTranslation } from 'react-i18next'
import { Routes, Route, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { profileStore } from './stores/profileStore'
import { authStore } from './stores/authStore'
import LevelUpCelebration from './components/LevelUpCelebration'
import HitMoji from './games/HitMoji'
import Memoji from './games/Memoji'
import FindMoji from './games/FindMoji'
import ChessMoji from './games/ChessMoji'
import Evoji from './games/Evoji'
import QuizMoji from './games/QuizMoji'
import TimelineMoji from './games/TimelineMoji'
import Home from './pages/Home'
import Profile from './pages/Profile'
import Mojiland from './pages/Mojiland'
import DivingAcademy from './pages/DivingAcademy'
import Leaderboard from './pages/Leaderboard'
import Header from './components/Header'

// Rutas que tienen su propio layout (full screen, sin header)
const fullScreenRoutes = ['/memoji', '/hitmoji', '/findmoji', '/chessmoji', '/evoji', '/quizmoji', '/timeline', '/leaderboard']

const App = observer(() => {
  const { t } = useTranslation()
  const location = useLocation()
  const isFullScreen = fullScreenRoutes.includes(location.pathname)

  // Loading state
  if (authStore.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #2563eb, #7c3aed, #ec4899, #f97316)' }}>
        <div className="text-center">
          <img src="/logo.png" alt="PlanetMoji" className="w-20 h-20 mx-auto animate-bounce mb-4 drop-shadow-2xl" />
          <p className="text-white/80 text-lg font-medium">{t('common.loading')}</p>
        </div>
      </div>
    )
  }

  // Layout full screen para juegos inmersivos
  if (isFullScreen) {
    return (
      <>
        <LevelUpCelebration />
        <Routes>
        <Route path="/memoji" element={<Memoji />} />
        <Route path="/hitmoji" element={<HitMoji />} />
        <Route path="/findmoji" element={<FindMoji />} />
        <Route path="/chessmoji" element={<ChessMoji />} />
        <Route path="/evoji" element={<Evoji />} />
        <Route path="/quizmoji" element={<QuizMoji />} />
        <Route path="/timeline" element={<TimelineMoji />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
      </Routes>
      </>
    )
  }

  // Layout normal: header + main
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-100 via-slate-50 to-gray-100">
      <LevelUpCelebration />
      <Header profile={profileStore} />
      <main className="w-full">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/mojiland" element={<Mojiland />} />
          <Route path="/diving-academy" element={<DivingAcademy />} />
        </Routes>
      </main>
    </div>
  )
})

export default App
